import React from 'react';
import { Fade } from 'react-awesome-reveal';
import {
  FaShieldAlt, FaRobot, FaDatabase, FaRocket, FaChartLine, FaMicrosoft, FaGraduationCap, FaLock
} from 'react-icons/fa';
import Header from 'parts/Header';
import Footer from 'parts/Footer';
import Button from '../elements/Button';
import logo from '../assets/images/logo.png';

const features = [
  { title: "Cyber Security", desc: "Bescherm je bedrijf met geavanceerde beveiligingsoplossingen." },
  { title: "AI & LLM's", desc: "Implementeer krachtige AI-modellen voor betere besluitvorming en automatisering." },
  { title: "Data-analyse", desc: "Gebruik data om jouw processen slimmer en efficiënter te maken." },
  { title: "Marketing Automation", desc: "Automatiseer je marketingactiviteiten voor optimale prestaties." },
  { title: "SEO & Profilering", desc: "Verbeter online zichtbaarheid met krachtige SEO- en profileringstools." },
  { title: "Microsoft 365 & Copilot", desc: "Optimaliseer bedrijfsprocessen met Microsoft-tools en Copilot-integraties." },
  { title: "Training & Studies", desc: "Professionele trainingen op maat voor jou en je team." },
  { title: "Automatisering", desc: "Automatiseer processen en verhoog efficiëntie met slimme workflows." },
];

const navigationItems = [
  { name: 'Cyber Security', icon: <FaShieldAlt /> },
  { name: 'AI & LLMs', icon: <FaRobot /> },
  { name: 'Data', icon: <FaDatabase /> },
  { name: 'Automatisering', icon: <FaRocket /> },
  { name: 'SEO & Marketing', icon: <FaChartLine /> },
  { name: 'Microsoft 365', icon: <FaMicrosoft /> },
  { name: 'Trainingen', icon: <FaGraduationCap /> },
  { name: 'Privacy & Security', icon: <FaLock /> },
];

const partners = ["FARI", "OU", "VLAIO"];

export default function GalacticHomePage() {
  return (
    <div className="bg-gradient-to-r from-[#0a0a1d] to-[#14143a] min-h-screen text-white flex flex-col">
      <Header />

      {/* HERO-SECTION */}
      <section className="container mx-auto px-6 py-16 flex flex-col md:flex-row items-center">
        <div className="w-full md:w-1/2 flex flex-col mb-12 md:mb-0">
          <Fade triggerOnce direction="up">
            <h1 className="text-4xl md:text-6xl font-bold mb-4 leading-tight">
              Innovatie door data, AI & automatisering
            </h1>
          </Fade>
          <Fade triggerOnce direction="up" delay={200}>
            <p className="text-lg md:text-xl text-gray-200 mb-6">
              Wij begeleiden jouw organisatie naar een veiliger, slimmer en efficiënter universum met behulp van de nieuwste technologieën.
            </p>
          </Fade>
          <Fade triggerOnce direction="up" delay={400}>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button href="/discuss-project" type="link" className="bg-indigo-500 px-6 py-3 rounded-full font-bold hover:bg-indigo-600 transition duration-300">
                Neem contact op
              </Button>
              <Button href="/services" type="link" className="border-2 border-indigo-500 px-6 py-3 rounded-full font-bold hover:bg-indigo-500 transition duration-300">
                Bekijk diensten
              </Button>
            </div>
          </Fade>
        </div>

        <Fade triggerOnce direction="right" delay={600}>
          <img src={logo} alt="Galactic Automation" className="rounded-lg shadow-lg max-w-xs md:max-w-sm lg:max-w-md" />
        </Fade>
      </section>

      {/* FEATURES SECTION */}
      <section className="container mx-auto px-6 py-16">
        <Fade triggerOnce direction="up">
          <h2 className="text-4xl font-bold text-center mb-8">Onze expertises</h2>
        </Fade>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, idx) => (
            <Fade key={feature.title} triggerOnce direction="up" delay={idx * 100}>
              <div className="bg-white bg-opacity-10 p-6 rounded-lg shadow-md hover:bg-opacity-20 transition h-full">
                <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                <p className="text-gray-200 text-sm">{feature.desc}</p>
              </div>
            </Fade>
          ))}
        </div>
      </section>

      {/* NAVIGATION ICON BLOCK */}
      <section className="container mx-auto px-6 py-16 text-center">
        <Fade triggerOnce direction="up">
          <h2 className="text-4xl font-bold mb-4">Ontdek onze diensten</h2>
        </Fade>
        <div className="flex justify-center items-center flex-wrap">
          {navigationItems.map((item) => (
            <Fade key={item.name} triggerOnce direction="up">
              <Button href={`/${item.name.replace(/\s+/g, '').toLowerCase()}`} className="bg-indigo-600 bg-opacity-20 p-4 rounded-xl hover:bg-opacity-30 transition flex flex-col items-center m-2">
                <div className="text-3xl mb-2">{item.icon}</div>
                <div className="font-bold">{item.name}</div>
              </Button>
            </Fade>
          ))}
        </div>
      </section>

      {/* PARTNERS SECTION */}
      <section className="bg-black bg-opacity-30 py-12 text-center">
        <Fade triggerOnce direction="up">
          <h2 className="text-3xl font-bold mb-6">Enkele van onze klanten</h2>
          <div className="flex justify-center flex-wrap gap-6">
            {partners.map((partner) => (
              <div key={partner} className="bg-white text-indigo-800 px-6 py-2 rounded-lg shadow-md font-semibold text-lg">
                {partner}
              </div>
            ))}
          </div>
        </Fade>
      </section>

      <Footer />
    </div>
  );
}
